const DEFAULT_SIZES = {
    counter: { w: 2, h: 4, minH: 4, minW: 2 },
    table: { w: 5, h: 9, minH: 6, minW: 3 },
    chart: { w: 5, h: 9, minH: 6, minW: 3 },
}
export {
    DEFAULT_SIZES
}